import { useTranslate, HttpError } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Switch } from 'antd';
import type {
  TestimonialOut,
  TestimonialUpdateIn,
} from '@/api/generated/schemas';

export const TestimonialEdit = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps } = useForm<
    TestimonialOut,
    HttpError,
    TestimonialUpdateIn
  >({
    resource: 'feedback.testimonials',
    mutationMeta: { method: 'patch' },
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          name="author_name"
          label={t('feedback.testimonials.fields.author_name')}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="comment"
          label={t('feedback.testimonials.fields.comment')}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          name="is_promoted"
          label={t('feedback.testimonials.fields.is_promoted')}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
